/**
 * @generated SignedSource<<8be7e1c37c6b9bb138c49073c8ea2af4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CurrencyType = "CAD" | "EUR" | "USD" | "%future added value";
export type DataGranularity = "MONTHLY" | "WEEKLY" | "%future added value";
export type FbAccessTokenType = "LP" | "%future added value";
export type UpdateBrandRequest = {
  currencyType?: CurrencyType | null;
  dataGranularity?: DataGranularity | null;
  fbAccessTokenType?: FbAccessTokenType | null;
  featureFlagIds?: ReadonlyArray<string> | null;
  id: string;
  insightsThreshold?: number | null;
  metaAdAccountExternalId?: string | null;
  minAdSpend?: number | null;
  name?: string | null;
};
export type BrandFormUpdateMutation$variables = {
  input: UpdateBrandRequest;
};
export type BrandFormUpdateMutation$data = {
  readonly updateBrand: {
    readonly id: string;
  };
};
export type BrandFormUpdateMutation = {
  response: BrandFormUpdateMutation$data;
  variables: BrandFormUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminBrand",
    "kind": "LinkedField",
    "name": "updateBrand",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandFormUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandFormUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "86d7cefa5286141a6140cae45a8e723d",
    "id": null,
    "metadata": {},
    "name": "BrandFormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation BrandFormUpdateMutation(\n  $input: UpdateBrandRequest!\n) {\n  updateBrand(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7755a67f7ccaebd2d2e31cca8b9473a";

export default node;
